const MainRoutes = {
  path: '/',
  meta: {
    requiresAuth: true
  },
  component: () => import('@/layouts/full/FullLayout.vue'),
  children: [
    {
      name: 'Dashboard',
      path: '/dashboard/default',
      component: () => import('@/views/dashboards/cli-analytics/index.vue')
    },
    {
      name: 'Wallet Redirect',
      path: '/wallet',
      redirect: '/wallet/payments'
    },
    {
      name: 'Payments',
      path: '/wallet/payments',
      component: () => import('@/views/apps/wallet/Payments.vue')
    },
    {
      name: 'Invoice Generator',
      path: '/wallet/invoice',
      component: () => import('@/views/apps/wallet/InvoiceGenerator.vue')
    },
    {
      name: 'Invoices',
      path: '/wallet/invoices',
      component: () => import('@/views/apps/invoices/Invoices.vue')
    },
    {
      name: 'Transactions',
      path: '/transactions',
      component: () => import('@/views/apps/wallet/Transactions.vue')
    },
    {
      name: 'Call History',
      path: '/calls/history',
      component: () => import('@/views/apps/calls/CallHistory.vue')
    },
    {
      name: 'DID Numbers',
      path: '/numbers',
      component: () => import('@/views/apps/numbers/DidNumbers.vue')
    },
    {
      name: 'SIP Trunks',
      path: '/sip-trunks',
      component: () => import('@/views/apps/sip/SipTrunks.vue')
    },
    {
      path: '/settings',
      component: () => import('@/views/settings/SettingsView.vue'),
      children: [
        { path: '', redirect: '/settings/account' },
        {
          name: 'Settings Account',
          path: 'account',
          component: () => import('@/views/settings/sections/AccountSection.vue'),
        },
        {
          name: 'Settings Billing',
          path: 'billing',
          component: () => import('@/views/settings/sections/BillingSection.vue'),
        },
        {
          name: 'Settings Security',
          path: 'security',
          component: () => import('@/views/settings/sections/SecuritySection.vue'),
        },
        {
          name: 'Settings API',
          path: 'api',
          component: () => import('@/views/settings/sections/ApiAccessSection.vue'),
        },
      ],
    },
    {
      name: 'Profile',
      path: '/profile',
      component: () => import('@/views/apps/profile/Profile.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/dashboard/default'
    }
  ]
};

export default MainRoutes;
